import {useRef,useMemo} from "react";
import AppMenuItemRouteTabPopup from './AppMenuItemRouteTabPopup.js';
import COMPONENT_MAP from '../Repository/Components.js';

const AppMenuItemRouteTabs=({parentId,application,userData,parent})=>{
    const list_name='app_menu_item_route_tabs';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'AppMenuItemRouteTab'}
                entityParams={['app_menu_item_route_id='+parentId]}
                list_name={list_name}
                height={'50vh'}
                file={'AppMenuItemRouteTabs.js'}
                navigateOnNew={null}
                canCreateNew={false}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={AppMenuItemRouteTabPopup}
                parentContext={{
                    parent_field_name:'app_menu_item_route_id',
                    parent_field_value:null,
                    parent_name:'AppMenuItemRoute',
                }}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return renderListTab;
}
export default AppMenuItemRouteTabs;
